var _a;
export var ConfirmationFormOrigin;
(function (ConfirmationFormOrigin) {
    ConfirmationFormOrigin["LegacyPoliciesMigration"] = "legacyPoliciesMigration";
})(ConfirmationFormOrigin || (ConfirmationFormOrigin = {}));
export var CONFIRMATION_FORM_ORIGIN_PARAM = "origin";
export var DEFAULT_LEGACY_BACK_ROUTE = "/insurancePoliciesSummary";
var BACK_ROUTE_BY_ORIGIN = (_a = {},
    _a[ConfirmationFormOrigin.LegacyPoliciesMigration] = "/admin/legacy-policies-migration",
    _a);
var isConfirmationFormOrigin = function (value) {
    return Object.values(ConfirmationFormOrigin).includes(value);
};
export var resolveLegacyBackRoute = function (origin) {
    return origin && isConfirmationFormOrigin(origin)
        ? BACK_ROUTE_BY_ORIGIN[origin]
        : DEFAULT_LEGACY_BACK_ROUTE;
};
